import type { BuildHubRoleEnum } from 'generated/graphql';

interface CollaboratorsInviteData {
    buildHubId: string;
    emails: string[];
    role?: BuildHubRoleEnum;
    message?: string;
}

/**
 * Builds FormData for inviting collaborators to BuildHub.
 */
export function buildFormDataForCollaboratorsInvite(
    data: CollaboratorsInviteData
): FormData {
    const formData = new FormData();
    formData.append('buildHubId', data.buildHubId);
    data.emails.forEach((email) => {
        formData.append('emails[]', email);
    });
    if (data.role) {
        formData.append('role', data.role);
    }
    if (data.message) {
        formData.append('message', data.message);
    }

    return formData;
}
